import { useEffect, useState } from "react";
import { UiComponents, initializeConfig, UnoStoreHooks } from "@simulanisindia/ui";
import { jwtDecode } from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Routes, Route, Navigate, useParams } from "react-router-dom";
import AppRouter from "./components/AppRouter";
import { applicationId, UNO_URL } from "./env.js";
import Login from "./pages/Login.js";
import Header from "./components/Header/Header.jsx";
import SideBar from "./components/SideBar/SideBar.jsx";
import ResetPassword from "./pages/ResetPassword";
import { fetchInitialAppData } from "./apiClient/apiService.js";
import jwtEncode from "jwt-encode";
import useWindowDimensions from "./utils/useWindowDimension.js";
import { isMobile } from "./utils/common.js";
import { saveMobileView } from "./store/slice/configSlice.js";
import { BottomNavigation } from "@mui/material";
import BottomNavigationBar from "./components/ForMobile/BottomNavigationBar.js";

const { MainLayout, FullScreenLoader } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { channelId } = useParams();
  const [loading, setLoading] = useState(true);
  const [showPage, setShowPage] = useState(false);
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const currentURL = window.location.href;
  const urlObject = new URL(currentURL);
  const referrerUrlParam = urlObject.searchParams.get("referrer");
  const windowDimensions = useWindowDimensions();

  const { isMobile: isMobileView } = useSelector((state) => state.configSlice);
  const initializeApp = async () => {
    setLoading(true);
    if (!userData?.token) {
      await initializeConfig({applicationId: applicationId, authTokenKey:"token", UNO_URL: UNO_URL, shouldRefer: false, checkReferrer: true}).finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    initializeApp();
  }, [userData?.token]);

  useEffect(() => {
    if (loading) return;

    if (referrerUrlParam) {
      const decoded = jwtDecode(referrerUrlParam);

      if(decoded?.logout === true){
       localStorage.clear();
       window.location.reload();
       return
      }

      let tokenPayload = { ...decoded };

      if (userData?.token) {
        tokenPayload["token"] = userData.token;
      }

      if (decoded.origin) {
        const encodedRefer = jwtEncode(tokenPayload, "");
        navigate(channelId ? `/gateway/${channelId}?referrer=${encodedRefer}` : `/gateway?referrer=${encodedRefer}`);
      }
    }

    if (userData.token) {
      setShowPage(true);
      const config = { ...configData.config };
      config["UNO_URL"] = UNO_URL;
      fetchInitialAppData(dispatch, config, userData);
      setLoading(false);
    } else {
      setShowPage(true);
    }
  }, [userData?.user, loading, userData?.user?.group]);

  useEffect(() => {
    const isMobileView = isMobile(windowDimensions.width, windowDimensions.height);
    dispatch(saveMobileView(isMobileView));
  }, [windowDimensions.height, windowDimensions.width]);

  useEffect(() => {
  if (isMobileView) {
    document.body.classList.add("mobile-view");
  } else {
    document.body.classList.remove("mobile-view");
  }
}, [isMobileView]);


  return (
    <>
      {!showPage ? (
        <FullScreenLoader loading={loading} />
      ) : (
        <>
          {userData?.token ? (
            userData?.user?.group ? (
              <>
                {isMobileView ? (
                  <>
                    <div className="mobileView">
                      <BottomNavigationBar isMobileView={isMobileView} />
                      <AppRouter isMobileView={isMobileView} />
                    </div>
                  </>
                ) : (
                  <MainLayout Header={<Header />} SideBar={<SideBar />} Component={<AppRouter />} />
                )}
              </>
            ) : (
              <FullScreenLoader loading={loading} />
            )
          ) : (
            <Routes>
              <Route path="/gateway" element={<Login />} />
              <Route path="/gateway/:channelId" element={<Login />} />
              <Route path="/set-new-password" element={<ResetPassword />} />
              <Route path="*" element={<Navigate to={"/gateway"} />} />
            </Routes>
          )}
        </>
      )}
    </>
  );
}

export default App;
